export default "__VITE_PUBLIC_ASSET__175775fe__"